import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcomeBackIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_136_2386)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 30,
					cy: 30,
					r: 30,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.25 30.2308L24.1427 40.504C24.9294 41.3209 26.2373 41.3209 27.024 40.504L47.25 19.5",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.25 24.15L23.9944 27.857C24.7738 28.6286 26.0292 28.6286 26.8086 27.857L35.25 19.5",
					stroke: "#865E9C",
					strokeWidth: 3,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_136_2386",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgWelcomeBackIcon);
export { ForwardRef as ReactComponent };
